import { useWidgetFactory } from "../widgets/WidgetsFactory"


const shortcodeMatch = new RegExp(/\[([^\/].*?)\]/, "gim");
const applyShortcodes = (content: string, additionalWidgets?: Array<any>) => {
    if (!content) return content;

    var result = unwrapShortcodes(content, additionalWidgets);

    const matches = content.matchAll(shortcodeMatch);
    for (const match of matches) {
        const sc = FindShortcode(match[0], additionalWidgets);
        if (sc == null) {
            console.warn("Shortcode not found: " + match[0]);
            continue;
        }

        const open = sc.createHtmlOpenTag(match);
        const close = sc.createHtmlCloseTag(match);

        result = result
            .replaceAll(match[0], open)
            .replaceAll("[/" + sc.htmlTagName + "]", close);
    }

    return result;
};


const shortcodeTagRegex = /\[([^\s]*).*?\]/;
const FindShortcode = (code: { match: (arg0: RegExp) => any[]; replace: (arg0: any, arg1: string) => string }, additionalWidgets?: Array<any>) => {
    const tag = code.match(shortcodeTagRegex)[1];

    const widgetFactory = useWidgetFactory(additionalWidgets);
    const widget = widgetFactory.findWidget(tag);

    if (widget) {
        if (!widget.component.NAME)
            throw new Error("Widget component has no 'NAME'. From shortcode: " + widget.shortcode);

        var attributes = '';
        if (widget.attributes)
            for (const [key, value] of Object.entries(widget.attributes)) {
                attributes += ` ${key}={${value}}`;
            }
        return {
            htmlTagName: tag,
            createHtmlOpenTag: (_shortcode: string) => {
                return code.replace(tag, widget.component.NAME + attributes).replace("[", "<").replace("]", ">")
            },
            createHtmlCloseTag: (_shortcode: string) => {
                return `</${widget.component.NAME}>`;
            },
        }
    };

    return null;
};

const tagRegex = new RegExp(/<.*?>(.*?)<\/.*?>/, "gim");
const unwrapShortcodes = (content: string, additionalWidgets?: Array<any>): string => {
    const groups = content.matchAll(tagRegex);

    var result = content;

    for (const group of groups) {
        if (!checkUnwrapShortcodes(group[1], additionalWidgets))
            result = result.replace(group[0], group[1]);
    }

    return result;
}


const shortcodeOpenMatch = new RegExp(/\[([^\/].*?)\]/, "gim");
const shortcodeCloseMatch = new RegExp(/\[\/(.*?)\]/, "gim");
const shortcodeOpenTagRegex = /\[([^\s]*).*?\]/;
const shortcodeCloseTagRegex = /\[\/([^\s]*).*?\]/;
export function checkUnwrapShortcodes(text: string, additionalWidgets?: Array<any>) {
    const openMatches = text.matchAll(shortcodeOpenMatch);
    const closeMatches = text.matchAll(shortcodeCloseMatch);
    var openTags = [];
    var closeTags = [];
    for (const shortcode of openMatches) {
        openTags.push(shortcode[0].match(shortcodeOpenTagRegex)[1]);
    }
    for (const shortcode of closeMatches) {
        closeTags.push(shortcode[0].match(shortcodeCloseTagRegex)[1])
    }

    if (openTags.length !== closeTags.length) //unwrap if there aren't equal open and close tags
        return false;

    openTags.sort();
    closeTags.sort();

    for (var i = 0; i < openTags.length; i++) {
        if (openTags[i] !== closeTags[i]) //unwrap if shortcode tag don't match i.e. not same shortcode
            return false;
        else {
            const widgetFactory = useWidgetFactory(additionalWidgets);
            const widget = widgetFactory.findWidget(openTags[i]);
            if (widget.unwrapComponent) //unwrap if shortcode requires unwrapping
                return false;
        }
    }

    return true;
}



export default function () {
    return {
        applyShortcodes: applyShortcodes
    }
}
